module.exports = __webpack_public_path__ + "cf8dad91767ad1ee8286e5e1b28e7191.pdf";